'use strict';
require('bootstrap/dist/js/bootstrap');
let wNumb = require('wnumb');
let slick = require('slick-carousel');
let noUiSlider = require('nouislider');

(function () {

    let sliders = document.getElementsByClassName('range-slider');

    for ( let i = 0; i < sliders.length; i++ ) {

        noUiSlider.create(sliders[i], {
            start: 0,
            connect: [true, false],
            tooltips: true,
            step:10000,
            range: {
                'min': 0,
                'max': 100000
            }
        });
    }

    $('.slider').slick({
        dots: true,
        prevArrow: '<div class="slider__arrow-container left"><i class="icon icon-arrow-left"></i></div>',
        nextArrow: '<div class="slider__arrow-container right"><i class="icon icon-arrow-right"></i></div>',
    });

    $('.product-slider').slick({
        dots: true,
        speed: 500,
        fade: false,
        centerMode: true,
        slidesToShow: 1,
        arrows:false,
        customPaging: function (slider, i) {
            return $('.slick-thumbs li:nth-child(' + (i + 1) + ')').html();
        }
    });

    $('.slick-thumbs').html('');
    $('.slick-dots').appendTo('.slick-thumbs');

})();


//////////////////
// WEBPACK FOOTER
// ./assets/js/scripts.js
// module id = 1
// module chunks = 0